var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.tipoComprobante === _vm.codigoFactura
                    ? "Factura"
                    : _vm.tipoComprobante === _vm.codigoNotaCredito
                    ? "Nota de crédito"
                    : _vm.tipoComprobante === _vm.codigoProforma
                    ? "Proforma"
                    : "Nota de venta"
                ) +
                "\n        " +
                _vm._s(_vm.numero_comprobante) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("label", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "PPR" && _vm.anulado === "N",
                    expression: "estado === 'PPR' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-warning"
              },
              [_c("strong", [_vm._v("PENDIENTE DE AUTORIZACIÓN")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.anulado === "S",
                    expression: "anulado === 'S'"
                  }
                ],
                staticClass: "noti-danger"
              },
              [_c("strong", [_vm._v("ANULADO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      (_vm.estado === undefined || _vm.estado === null) &&
                      _vm.anulado === "N" &&
                      !_vm.enColaAutorizacion,
                    expression:
                      "\n          (estado === undefined || estado === null) &&\n          anulado === 'N' &&\n          !enColaAutorizacion\n        "
                  }
                ],
                staticClass: "noti-info"
              },
              [_c("strong", [_vm._v("EMITIDO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "AUT" && _vm.anulado === "N",
                    expression: "estado === 'AUT' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-success"
              },
              [_c("strong", [_vm._v("AUTORIZADO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "N" && _vm.anulado === "N",
                    expression: "estado === 'N' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-secondary"
              },
              [_c("strong", [_vm._v("NUEVO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "NAT" && _vm.anulado === "N",
                    expression: "estado === 'NAT' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-danger"
              },
              [_c("strong", [_vm._v("NO AUTORIZADO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.enColaAutorizacion,
                    expression: "enColaAutorizacion"
                  }
                ],
                staticClass: "noti-primary"
              },
              [_c("strong", [_vm._v("PENDIENTE DE ENVÍO AL SRI")])]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c(
            "form",
            {
              staticClass: "form-inline",
              attrs: {
                action:
                  _vm.url + "/subir-comprobante-venta/" + _vm.id_comprobante,
                method: "POST",
                enctype: "multipart/form-data"
              },
              on: { submit: _vm.submitFoto }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado !== "N" && _vm.anulado !== "S",
                    expression: "estado !== 'N' && anulado !== 'S'"
                  }
                ],
                attrs: { type: "file", name: "path_foto", id: "path_foto" }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "_token" },
                domProps: { value: _vm.token }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N" && _vm.anulado !== "S",
                      expression: "estado !== 'N' && anulado !== 'S'"
                    }
                  ],
                  staticClass: "btn-success btn--bigger",
                  attrs: { type: "submit" }
                },
                [
                  _c("i", { staticClass: "fa fa-upload" }),
                  _c("span", [_vm._v("Subir")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.estado !== "N" &&
                        _vm.path_foto != "" &&
                        _vm.path_foto != null,
                      expression:
                        "estado !== 'N' && path_foto != '' && path_foto != null"
                    }
                  ],
                  staticClass: "btn-info btn--bigger",
                  attrs: { type: "button" },
                  on: { click: _vm.descargarArchivo }
                },
                [
                  _c("i", { staticClass: "fa fa-download" }),
                  _c("span", [_vm._v("Ver documento(s)")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-bus200 btn--bigger",
                  attrs: {
                    disabled:
                      !_vm.permiteEliminarComprobante &&
                      !_vm.permiteEditarComprobante,
                    type: "button"
                  },
                  on: { click: _vm.consultarComprobantes }
                },
                [
                  _c("i", { staticClass: "fa fa-search" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Buscar comprobantes")])
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main" }, [
        _c("div", { staticClass: "layout__main-form" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__title" }, [
              _c("h5", [_vm._v("Información del comprobante")]),
              _vm._v(" "),
              _c("div", { staticClass: "card__controls" }, [
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.tipoComprobante === _vm.codigoFactura &&
                          !_vm.datos_factura_resumida,
                        expression:
                          "(tipoComprobante === codigoFactura && !datos_factura_resumida)"
                      }
                    ]
                  },
                  [
                    _c("label", { attrs: { for: "factura_exterior" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.factura_exterior,
                            expression: "form.factura_exterior"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "factura_exterior",
                          id: "factura_exterior"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.form.factura_exterior)
                            ? _vm._i(_vm.form.factura_exterior, null) > -1
                            : _vm.form.factura_exterior
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.form.factura_exterior,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "factura_exterior",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "factura_exterior",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "factura_exterior", $$c)
                            }
                          }
                        }
                      }),
                      _c("span", [_vm._v("Factura del Exterior")])
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.tipoComprobante === _vm.codigoNotaCredito ||
                          (_vm.tipoComprobante === _vm.codigoFactura &&
                            !_vm.datos_factura_resumida),
                        expression:
                          "\n              tipoComprobante === codigoNotaCredito ||\n              (tipoComprobante === codigoFactura && !datos_factura_resumida)\n            "
                      }
                    ],
                    staticClass: "col-xs-12 col-md-6"
                  },
                  [
                    _c("div", { staticClass: "form-field" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "input-field",
                            {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: "###-###-#########",
                                  expression: "'###-###-#########'"
                                }
                              ],
                              attrs: {
                                readonly: "",
                                type: "tel",
                                id: "comprobanteAfectado",
                                placeholder: "N° comprobante"
                              },
                              model: {
                                value: _vm.form.numero_comprobante_afectado,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "numero_comprobante_afectado",
                                    $$v
                                  )
                                },
                                expression: "form.numero_comprobante_afectado"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.tipoComprobante === _vm.codigoFactura
                                      ? "Proforma"
                                      : "Comprobante afectado"
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.form.tipo_comprobante_afectado === "",
                                  expression:
                                    "form.tipo_comprobante_afectado === ''"
                                }
                              ],
                              staticClass: "btn-info",
                              attrs: {
                                disabled: !_vm.editable,
                                type: "button"
                              },
                              on: { click: _vm.consultarComprobantesVenta }
                            },
                            [_c("i", { staticClass: "fa fa-search" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.form.tipo_comprobante_afectado !== "",
                                  expression:
                                    "form.tipo_comprobante_afectado !== ''"
                                }
                              ],
                              staticClass: "btn-danger",
                              attrs: { disabled: !_vm.editable },
                              on: { click: _vm.quitarComprobanteAfectado }
                            },
                            [_c("i", { staticClass: "fa fa-ban" })]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.tipoComprobante === _vm.codigoNotaCredito ||
                          (_vm.tipoComprobante === _vm.codigoFactura &&
                            !_vm.datos_factura_resumida),
                        expression:
                          "\n              tipoComprobante === codigoNotaCredito ||\n              (tipoComprobante === codigoFactura && !datos_factura_resumida)\n            "
                      }
                    ],
                    staticClass: "col-xs-12 col-md-6"
                  },
                  [
                    _c("div", { staticClass: "form-field" }, [
                      _c(
                        "div",
                        { staticClass: "datepicker-field" },
                        [
                          _c("VueCtkDateTimePicker", {
                            attrs: {
                              disabled: "",
                              id: "fecha_emision_comprobante_afectado",
                              locale: "es",
                              "no-label": "",
                              "only-date": "",
                              "auto-close": "",
                              "button-now-translation": "Ahora",
                              format: "YYYY-MM-DD",
                              formatted: "YYYY-MM-DD",
                              label: "Seleccione una fecha..."
                            },
                            model: {
                              value:
                                _vm.form.fecha_emision_comprobante_afectado,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "fecha_emision_comprobante_afectado",
                                  $$v
                                )
                              },
                              expression:
                                "form.fecha_emision_comprobante_afectado"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              attrs: {
                                for: "fecha_emision_comprobante_afectado"
                              }
                            },
                            [_vm._v("Fecha de emisión del comprobante *")]
                          ),
                          _vm._v(" "),
                          _vm.errores.fecha_emision_comprobante_afectado
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errores
                                          .fecha_emision_comprobante_afectado[0]
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.estado == "N",
                        expression: "estado == 'N'"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "form-field select2",
                        class: { "select2--disabled": _vm.estado !== "N" }
                      },
                      [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "div",
                            { staticClass: "select2-field" },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: "descripcion",
                                  options: _vm.puntosEmision,
                                  id: "punto_emision",
                                  placeholder: "Seleccione..."
                                },
                                on: { input: _vm.inputPuntoEmision },
                                model: {
                                  value: _vm.selectedPuntoEmision,
                                  callback: function($$v) {
                                    _vm.selectedPuntoEmision = $$v
                                  },
                                  expression: "selectedPuntoEmision"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "punto_emision" } }, [
                                _vm._v("Punto de emisión *")
                              ]),
                              _vm._v(" "),
                              _vm.errores.id_punto_emision
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores.id_punto_emision[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.tipoComprobante !== "00" &&
                          !_vm.esElectronico &&
                          _vm.estado === "N",
                        expression:
                          "\n              tipoComprobante !== '00' && !esElectronico && estado === 'N'\n            "
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-field" },
                      [
                        _c(
                          "input-field",
                          {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "#########",
                                expression: "'#########'"
                              }
                            ],
                            attrs: {
                              type: "tel",
                              id: "numero_documento",
                              placeholder: "#########"
                            },
                            model: {
                              value: _vm.form.numero_documento,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "numero_documento", $$v)
                              },
                              expression: "form.numero_documento"
                            }
                          },
                          [
                            _c("span", [_vm._v("Número de documento")]),
                            _vm._v(" "),
                            _vm.errores.numero_documento
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.errores.numero_documento[0])
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              readonly:
                                (_vm.form.id_cliente !== null &&
                                  _vm.form.id_cliente !== "") ||
                                (_vm.tipoComprobante !== _vm.codigoFactura &&
                                  _vm.tipoComprobante !== _vm.codigoProforma &&
                                  _vm.tipoComprobante !== _vm.codigoNotaVenta),
                              id: "identificacion",
                              placeholder: "# Identificación"
                            },
                            model: {
                              value: _vm.numero_identificacion,
                              callback: function($$v) {
                                _vm.numero_identificacion = $$v
                              },
                              expression: "numero_identificacion"
                            }
                          },
                          [
                            _c("span", [_vm._v("Identificación *")]),
                            _vm._v(" "),
                            _vm.errores.id_cliente
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.errores.id_cliente[0]))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  (_vm.form.id_cliente === null ||
                                    _vm.form.id_cliente === "") &&
                                  (_vm.tipoComprobante === _vm.codigoFactura ||
                                    _vm.tipoComprobante ===
                                      _vm.codigoProforma ||
                                    _vm.tipoComprobante ===
                                      _vm.codigoNotaVenta),
                                expression:
                                  "\n                    (form.id_cliente === null || form.id_cliente === '') &&\n                    (tipoComprobante === codigoFactura ||\n                      tipoComprobante === codigoProforma ||\n                      tipoComprobante === codigoNotaVenta)\n                  "
                              }
                            ],
                            staticClass: "btn-success",
                            attrs: { disabled: !_vm.editable, type: "button" },
                            on: { click: _vm.consultarCliente }
                          },
                          [_c("i", { staticClass: "fa fa-check" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.form.id_cliente !== null &&
                                  _vm.form.id_cliente !== "" &&
                                  (_vm.tipoComprobante === _vm.codigoFactura ||
                                    _vm.tipoComprobante ===
                                      _vm.codigoProforma ||
                                    _vm.tipoComprobante ===
                                      _vm.codigoNotaVenta),
                                expression:
                                  "\n                    form.id_cliente !== null &&\n                    form.id_cliente !== '' &&\n                    (tipoComprobante === codigoFactura ||\n                      tipoComprobante === codigoProforma ||\n                      tipoComprobante === codigoNotaVenta)\n                  "
                              }
                            ],
                            staticClass: "btn-danger",
                            attrs: { disabled: !_vm.editable, type: "button" },
                            on: { click: _vm.quitarCliente }
                          },
                          [_c("i", { staticClass: "fa fa-ban" })]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              readonly: "",
                              id: "cliente",
                              placeholder: "Nombre de cliente"
                            },
                            model: {
                              value: _vm.nombre_cliente,
                              callback: function($$v) {
                                _vm.nombre_cliente = $$v
                              },
                              expression: "nombre_cliente"
                            }
                          },
                          [_c("span", [_vm._v("Cliente *")])]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.tipoComprobante === _vm.codigoFactura ||
                                  _vm.tipoComprobante === _vm.codigoProforma ||
                                  _vm.tipoComprobante === _vm.codigoNotaVenta,
                                expression:
                                  "\n                    tipoComprobante === codigoFactura ||\n                    tipoComprobante === codigoProforma ||\n                    tipoComprobante === codigoNotaVenta\n                  "
                              }
                            ],
                            staticClass: "btn-info",
                            attrs: { disabled: !_vm.editable, type: "button" },
                            on: { click: _vm.consultarPersonas }
                          },
                          [_c("i", { staticClass: "fa fa-search" })]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("date-picker", {
                          attrs: {
                            disabled: !_vm.editable,
                            type: "date",
                            format: "dd-MM-yyyy",
                            id: "fecha_emision",
                            lang: "es"
                          },
                          nativeOn: {
                            keyup: function($event) {
                              return _vm.actualizarFechaVencimiento.apply(
                                null,
                                arguments
                              )
                            }
                          },
                          model: {
                            value: _vm.form.fecha_emision,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_emision", $$v)
                            },
                            expression: "form.fecha_emision"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "fecha_emision" } }, [
                          _vm._v("Fecha de emisión *")
                        ]),
                        _vm._v(" "),
                        _vm.errores.fecha_emision
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.fecha_emision[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            disabled: !_vm.editable,
                            id: "email",
                            placeholder: "Correo del cliente"
                          },
                          model: {
                            value: _vm.form.email,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "email", $$v)
                            },
                            expression: "form.email"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v('E-mail ("," para separar varios)')
                          ]),
                          _vm._v(" "),
                          _vm.errores.email
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.email[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.tipoComprobante !== "00" &&
                          !_vm.datos_factura_resumida,
                        expression:
                          "tipoComprobante !== '00' && !datos_factura_resumida"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-field" },
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              readonly: "",
                              id: "clave_acceso",
                              placeholder: "################"
                            },
                            model: {
                              value: _vm.clave_acceso,
                              callback: function($$v) {
                                _vm.clave_acceso = $$v
                              },
                              expression: "clave_acceso"
                            }
                          },
                          [_c("span", [_vm._v("Clave de acceso")])]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.tipoComprobante !== "00" &&
                          !_vm.datos_factura_resumida,
                        expression:
                          "tipoComprobante !== '00' && !datos_factura_resumida"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field" }, [
                      _c(
                        "div",
                        { staticClass: "datepicker-field" },
                        [
                          _c("date-picker", {
                            attrs: {
                              disabled: "",
                              type: "datetime",
                              format: "dd-MM-yyyy HH:mm:ss",
                              id: "fecha_autorizacion",
                              lang: "es"
                            },
                            model: {
                              value: _vm.form.fecha_autorizacion,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fecha_autorizacion", $$v)
                              },
                              expression: "form.fecha_autorizacion"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "fecha_autorizacion" } },
                            [_vm._v("Fecha de autorización *")]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.tipoComprobante !== "00" &&
                          !_vm.datos_factura_resumida,
                        expression:
                          "tipoComprobante !== '00' && !datos_factura_resumida"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-field" },
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              readonly: "",
                              placeholder: "#############",
                              id: "numero_autorizacion"
                            },
                            model: {
                              value: _vm.form.numero_autorizacion,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "numero_autorizacion", $$v)
                              },
                              expression: "form.numero_autorizacion"
                            }
                          },
                          [_c("span", [_vm._v("N° Autorización")])]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.tipoComprobante !== "00" &&
                          !_vm.datos_factura_resumida,
                        expression:
                          "tipoComprobante !== '00' && !datos_factura_resumida"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "form-field select2",
                        class: {
                          "select2--disabled":
                            _vm.tipoComprobante !== _vm.codigoFactura ||
                            _vm.tipoComprobante !== _vm.codigoProforma ||
                            _vm.tipoComprobante !== _vm.codigoNotaVenta ||
                            !_vm.editable
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "select2-field" },
                          [
                            _c("v-select", {
                              attrs: {
                                label: "descripcion",
                                options: _vm.monedas,
                                id: "moneda",
                                placeholder: "Seleccione..."
                              },
                              model: {
                                value: _vm.selectedMoneda,
                                callback: function($$v) {
                                  _vm.selectedMoneda = $$v
                                },
                                expression: "selectedMoneda"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "moneda" } }, [
                              _vm._v("Moneda *")
                            ]),
                            _vm._v(" "),
                            _vm.errores.id_moneda
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.errores.id_moneda[0]))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-field select2",
                      class: {
                        "select2--disabled":
                          _vm.tipoComprobante === _vm.codigoNotaCredito ||
                          !_vm.editable
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              label: "nombre",
                              options: _vm.vendedores,
                              id: "vendedor",
                              placeholder: "Seleccione..."
                            },
                            model: {
                              value: _vm.selectedVendedor,
                              callback: function($$v) {
                                _vm.selectedVendedor = $$v
                              },
                              expression: "selectedVendedor"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "vendedor" } }, [
                            _vm._v("Vendedor *")
                          ]),
                          _vm._v(" "),
                          _vm.errores.vendedor_id
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.vendedor_id[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tipoComprobante === _vm.codigoNotaCredito,
                        expression: "tipoComprobante === codigoNotaCredito"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "form-field select2",
                        class: { "select2--disabled": !_vm.editable }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "select2-field" },
                          [
                            _c("v-select", {
                              attrs: { options: _vm.motivos, id: "motivo" },
                              model: {
                                value: _vm.form.selectedMotivo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "selectedMotivo", $$v)
                                },
                                expression: "form.selectedMotivo"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "motivo" } }, [
                              _vm._v("Motivo *")
                            ]),
                            _vm._v(" "),
                            _vm.errores.selectedMotivo
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.errores.selectedMotivo[0])
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tipoComprobante === _vm.codigoNotaCredito,
                        expression: "tipoComprobante === codigoNotaCredito"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-field" },
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              disabled: !_vm.editable,
                              id: "descripcionMotivo",
                              placeholder: "Escriba el motivo..."
                            },
                            model: {
                              value: _vm.form.motivo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "motivo", $$v)
                              },
                              expression: "form.motivo"
                            }
                          },
                          [
                            _c("span", [_vm._v("Descripción del motivo")]),
                            _vm._v(" "),
                            _vm.errores.motivo
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.errores.motivo[0]))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.tipoComprobante == _vm.codigoFactura &&
                          !_vm.datos_factura_resumida,
                        expression:
                          "tipoComprobante == codigoFactura && !datos_factura_resumida"
                      }
                    ],
                    class: {
                      "col-xs-12 col-md-8": !_vm.moduloProyecto,
                      "col-xs-12 col-md-4": _vm.moduloProyecto
                    }
                  },
                  [
                    _c("div", { staticClass: "form-field select" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "div",
                          { staticClass: "select2-field" },
                          [
                            _c("v-select", {
                              attrs: {
                                label: "numero",
                                multiple: "",
                                options: _vm.form.compras,
                                id: "compras",
                                placeholder: "Seleccione..."
                              },
                              model: {
                                value: _vm.form.compras,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "compras", $$v)
                                },
                                expression: "form.compras"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "compras" } }, [
                              _vm._v("Compras")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn-info",
                            attrs: { type: "button" },
                            on: { click: _vm.consultarCompras }
                          },
                          [_c("i", { staticClass: "fa fa-search" })]
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.tipoComprobante == _vm.codigoFactura &&
                          _vm.moduloProyecto,
                        expression:
                          "tipoComprobante == codigoFactura && moduloProyecto"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              multiple: "",
                              id: "proyecto_id",
                              placeholder: "Busque y seleccione...",
                              label: "nombre",
                              options: _vm.optionProyectos
                            },
                            on: {
                              search: _vm.onSearchProyecto,
                              input: _vm.inputProyecto
                            },
                            model: {
                              value: _vm.selectedProyectos,
                              callback: function($$v) {
                                _vm.selectedProyectos = $$v
                              },
                              expression: "selectedProyectos"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "proyecto_id" } }, [
                            _vm._v("Proyectos")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-info",
                          attrs: { type: "button" },
                          on: { click: _vm.consultarProyectos }
                        },
                        [_c("i", { staticClass: "fa fa-search" })]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.tipoComprobante === _vm.codigoFactura &&
                          _vm.referenciaOt !== "",
                        expression:
                          "\n              tipoComprobante === codigoFactura && referenciaOt !== ''\n            "
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                id: "referenciaOt",
                                value: _vm.referenciaOt,
                                readonly: ""
                              }
                            },
                            [_vm._v("Orden de trabajo")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-info btn--text",
                          attrs: { type: "button" },
                          on: { click: _vm.verOt }
                        },
                        [_c("i", { staticClass: "fa fa-eye" })]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "form-field select2",
                        class: {
                          "select2--disabled":
                            _vm.tipoComprobante !== _vm.codigoFactura &&
                            _vm.tipoComprobante !== _vm.codigoProforma &&
                            _vm.tipoComprobante !== _vm.codigoNotaVenta
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "select2-field" },
                          [
                            _c("v-select", {
                              attrs: {
                                label: "descripcion",
                                options: _vm.tiposEmision,
                                id: "tipo_emision",
                                placeholder: "Seleccione..."
                              },
                              model: {
                                value: _vm.selectedTipoEmision,
                                callback: function($$v) {
                                  _vm.selectedTipoEmision = $$v
                                },
                                expression: "selectedTipoEmision"
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "tipo_emision" } }, [
                              _vm._v("Tipo de emisión *")
                            ]),
                            _vm._v(" "),
                            _vm.errores.id_tipo_emision
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.errores.id_tipo_emision[0])
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.factura_exterior,
                        expression: "form.factura_exterior"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field select" }, [
                      _c("div", { staticClass: "select-field" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.incoterm_factura,
                                expression: "form.incoterm_factura"
                              }
                            ],
                            attrs: {
                              name: "incoterm_factura",
                              id: "incoterm_factura"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.form,
                                  "incoterm_factura",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("Seleccione...")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.tiposIncoterm, function(tipo) {
                              return _c(
                                "option",
                                { key: tipo, domProps: { value: tipo } },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(tipo) +
                                      "\n                    "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "incoterm_factura" } }, [
                          _vm._v("Incoterm Factura")
                        ]),
                        _vm._v(" "),
                        _vm.errores.incoterm_factura
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.errores.incoterm_factura[0])
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.factura_exterior,
                        expression: "form.factura_exterior"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field select2" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              placeholder: "Seleccione...",
                              label: "descripcion",
                              id: "prov_incoterm_id",
                              options: _vm.provincias
                            },
                            on: { input: _vm.inputProvincia },
                            model: {
                              value: _vm.selectedProvincia,
                              callback: function($$v) {
                                _vm.selectedProvincia = $$v
                              },
                              expression: "selectedProvincia"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "prov_incoterm_id" } }, [
                            _vm._v("Provincia")
                          ]),
                          _vm._v(" "),
                          _vm.errores.prov_incoterm_id
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.errores.prov_incoterm_id[0])
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.factura_exterior,
                        expression: "form.factura_exterior"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field select2" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              placeholder: "Seleccione...",
                              label: "descripcion",
                              id: "lug_incoterm_id",
                              options: _vm.ciudades
                            },
                            on: { input: _vm.inputCiudad },
                            model: {
                              value: _vm.selectedCiudad,
                              callback: function($$v) {
                                _vm.selectedCiudad = $$v
                              },
                              expression: "selectedCiudad"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "lug_incoterm_id" } }, [
                            _vm._v("Lugar Incoterm")
                          ]),
                          _vm._v(" "),
                          _vm.errores.lug_incoterm_id
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.errores.lug_incoterm_id[0])
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.factura_exterior,
                        expression: "form.factura_exterior"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field select2" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              placeholder: "Seleccione...",
                              label: "descripcion",
                              id: "prov_embarque_id",
                              options: _vm.provincias
                            },
                            on: { input: _vm.inputProvinciaEmbarque },
                            model: {
                              value: _vm.selectedProvEmbarque,
                              callback: function($$v) {
                                _vm.selectedProvEmbarque = $$v
                              },
                              expression: "selectedProvEmbarque"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "prov_embarque_id" } }, [
                            _vm._v("Provincia de Embarque")
                          ]),
                          _vm._v(" "),
                          _vm.errores.prov_embarque_id
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.errores.prov_embarque_id[0])
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.factura_exterior,
                        expression: "form.factura_exterior"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field select2" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              placeholder: "Seleccione...",
                              label: "descripcion",
                              id: "pue_embarque_id",
                              options: _vm.ciudadesEmbarque
                            },
                            on: { input: _vm.inputCiudadEmbarque },
                            model: {
                              value: _vm.selectedCiudadEmbarque,
                              callback: function($$v) {
                                _vm.selectedCiudadEmbarque = $$v
                              },
                              expression: "selectedCiudadEmbarque"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "pue_embarque_id" } }, [
                            _vm._v("Puerto de Embarque")
                          ]),
                          _vm._v(" "),
                          _vm.errores.pue_embarque_id
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.errores.pue_embarque_id[0])
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.factura_exterior,
                        expression: "form.factura_exterior"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field select2" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              label: "descripcion",
                              placeholder: "Seleccione...",
                              name: "pais_adquisicion_id",
                              options: _vm.paises,
                              id: "pais_adquisicion_id"
                            },
                            on: { input: _vm.inputPais },
                            model: {
                              value: _vm.selectedPais,
                              callback: function($$v) {
                                _vm.selectedPais = $$v
                              },
                              expression: "selectedPais"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "pais_adquisicion_id" } },
                            [_vm._v("País de Adquisición")]
                          ),
                          _vm._v(" "),
                          _vm.errores.pais_adquisicion_id
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.errores.pais_adquisicion_id[0])
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.factura_exterior,
                        expression: "form.factura_exterior"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field select2" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              placeholder: "Seleccione...",
                              label: "descripcion",
                              id: "prov_destino_id",
                              options: _vm.provinciasDestino
                            },
                            on: { input: _vm.inputProvinciaDestino },
                            model: {
                              value: _vm.selectedProvDestino,
                              callback: function($$v) {
                                _vm.selectedProvDestino = $$v
                              },
                              expression: "selectedProvDestino"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "prov_destino_id" } }, [
                            _vm._v("Provincia de Destino")
                          ]),
                          _vm._v(" "),
                          _vm.errores.prov_destino_id
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.errores.prov_destino_id[0])
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.factura_exterior,
                        expression: "form.factura_exterior"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field select2" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              placeholder: "Seleccione...",
                              label: "descripcion",
                              id: "pue_destino_id",
                              options: _vm.ciudadesDestino
                            },
                            on: { input: _vm.inputPuertoDestino },
                            model: {
                              value: _vm.selectedPuertoDestino,
                              callback: function($$v) {
                                _vm.selectedPuertoDestino = $$v
                              },
                              expression: "selectedPuertoDestino"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "pue_destino_id" } }, [
                            _vm._v("Puerto de Destino")
                          ]),
                          _vm._v(" "),
                          _vm.errores.pue_destino_id
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.errores.pue_destino_id[0])
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.factura_exterior,
                        expression: "form.factura_exterior"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field select" }, [
                      _c("div", { staticClass: "select-field" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.incoterm_total_si,
                                expression: "form.incoterm_total_si"
                              }
                            ],
                            attrs: {
                              name: "incoterm_total_si",
                              id: "incoterm_total_si"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.form,
                                  "incoterm_total_si",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("Seleccione...")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.tiposIncoterm, function(tipo) {
                              return _c(
                                "option",
                                { key: tipo, domProps: { value: tipo } },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(tipo) +
                                      "\n                    "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "incoterm_total_si" } }, [
                          _vm._v("Incoterm Total S/I")
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.no_anular_consumidor_final_aut
                  ? _c("div", { staticClass: "col-xs-12" }, [_vm._m(0)])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card mt-0" }, [
            _c("div", { staticClass: "card__title" }, [
              _c("h5", [_vm._v("Detalles del comprobante")]),
              _vm._v(" "),
              _c("div", { staticClass: "card__controls" }, [
                _c("div", { staticClass: "form-field select2 my-0" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          placeholder: "Seleccione un item...",
                          id: "item",
                          options: _vm.items,
                          label: "descripcion_item"
                        },
                        on: { search: _vm.onSearchItems, input: _vm.inputItem },
                        model: {
                          value: _vm.selectedItem,
                          callback: function($$v) {
                            _vm.selectedItem = $$v
                          },
                          expression: "selectedItem"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__content" },
              [
                _c("tabla-detalle-comprobante", {
                  ref: "tablaDetalleComprobante",
                  attrs: {
                    iva_incluido_exp: _vm.iva_incluido_exp,
                    factura_exterior: _vm.form.factura_exterior,
                    retencionProductos: _vm.retencionProductos,
                    retencionServicios: _vm.retencionServicios,
                    precioEditable: _vm.permiteEditarPrecio,
                    tipo: "E",
                    disabled: !_vm.editable,
                    anulado: _vm.anulado,
                    tipoComprobante: _vm.tipoComprobante,
                    errores: _vm.errores,
                    irbpnr: _vm.irbpnr,
                    search: _vm.searchItems,
                    decimales_compras: _vm.precision
                  },
                  on: { input: _vm.inputDetalles },
                  model: {
                    value: _vm.form.items,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "items", $$v)
                    },
                    expression: "form.items"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.factura_exterior,
                  expression: "form.factura_exterior"
                }
              ],
              staticClass: "card"
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "card__content" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                    _c(
                      "div",
                      { staticClass: "form-field" },
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              id: "v_flete_internacional",
                              vMoney: "",
                              format: _vm.money
                            },
                            nativeOn: {
                              keyup: function($event) {
                                return _vm.calcularTotales.apply(
                                  null,
                                  arguments
                                )
                              }
                            },
                            model: {
                              value: _vm.form.v_flete_internacional,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "v_flete_internacional", $$v)
                              },
                              expression: "form.v_flete_internacional"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v("Valor de Flete Internacional")
                            ]),
                            _vm._v(" "),
                            _vm.errores.v_flete_internacional
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errores.v_flete_internacional[0]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                    _c(
                      "div",
                      { staticClass: "form-field" },
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              id: "v_seguro_internacional",
                              vMoney: "",
                              format: _vm.money
                            },
                            nativeOn: {
                              keyup: function($event) {
                                return _vm.calcularTotales.apply(
                                  null,
                                  arguments
                                )
                              }
                            },
                            model: {
                              value: _vm.form.v_seguro_internacional,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "v_seguro_internacional",
                                  $$v
                                )
                              },
                              expression: "form.v_seguro_internacional"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v("Valor de Seguro Internacional")
                            ]),
                            _vm._v(" "),
                            _vm.errores.v_seguro_internacional
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errores.v_seguro_internacional[0]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                    _c(
                      "div",
                      { staticClass: "form-field" },
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              id: "v_gastos_aduaneros",
                              vMoney: "",
                              format: _vm.money
                            },
                            nativeOn: {
                              keyup: function($event) {
                                return _vm.calcularTotales.apply(
                                  null,
                                  arguments
                                )
                              }
                            },
                            model: {
                              value: _vm.form.v_gastos_aduaneros,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "v_gastos_aduaneros", $$v)
                              },
                              expression: "form.v_gastos_aduaneros"
                            }
                          },
                          [
                            _c("span", [_vm._v("Valor de Gastos Aduanero")]),
                            _vm._v(" "),
                            _vm.errores.v_gastos_aduaneros
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errores.v_gastos_aduaneros[0]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-12 col-md-3" }, [
                    _c(
                      "div",
                      { staticClass: "form-field" },
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              id: "v_gastos_transporte_otros",
                              vMoney: "",
                              format: _vm.money
                            },
                            nativeOn: {
                              keyup: function($event) {
                                return _vm.calcularTotales.apply(
                                  null,
                                  arguments
                                )
                              }
                            },
                            model: {
                              value: _vm.form.v_gastos_transporte_otros,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "v_gastos_transporte_otros",
                                  $$v
                                )
                              },
                              expression: "form.v_gastos_transporte_otros"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v("Valor de Gastos de Otros Transportes")
                            ]),
                            _vm._v(" "),
                            _vm.errores.v_gastos_transporte_otros
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errores
                                            .v_gastos_transporte_otros[0]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.tipoComprobante === _vm.codigoFactura ||
                    _vm.tipoComprobante === _vm.codigoNotaVenta,
                  expression:
                    "\n        (tipoComprobante === codigoFactura) ||\n        tipoComprobante === codigoNotaVenta\n      "
                }
              ],
              staticClass: "card mt-0"
            },
            [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card__content" },
                [
                  _c("tabla-forma-pago", {
                    attrs: {
                      tiposUnidad: _vm.tiposUnidad,
                      disabled: !_vm.editable,
                      totalComprobante: _vm.form.total,
                      errores: _vm.errores,
                      formasPago: _vm.formasPago,
                      formaPagoIdDefault: _vm.formaPagoIdDefault
                    },
                    on: { updatedFormaPago: _vm.inputFormasPago },
                    model: {
                      value: _vm.form.formasPago,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "formasPago", $$v)
                      },
                      expression: "form.formasPago"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-7" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card__content" },
                  [
                    _c("tabla-informacion-adicional", {
                      attrs: {
                        enviable: "",
                        disabled: !_vm.editable,
                        errores: _vm.errores
                      },
                      model: {
                        value: _vm.form.informacionAdicional,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "informacionAdicional", $$v)
                        },
                        expression: "form.informacionAdicional"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-5" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-lg-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "subtotal_sin_impuestos",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.total_sin_impuestos,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "total_sin_impuestos", $$v)
                                },
                                expression: "form.total_sin_impuestos"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Subtotal S/I\n                      "
                              ),
                              _vm.errores.total_sin_impuestos
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores.total_sin_impuestos[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "descuento_total",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.descuento_total,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "descuento_total", $$v)
                                },
                                expression: "form.descuento_total"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Descuento total\n                      "
                              ),
                              _vm.errores.descuento_total
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.descuento_total[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "subtotal_no_iva",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.subtotal_no_sujeto_iva,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "subtotal_no_sujeto_iva",
                                    $$v
                                  )
                                },
                                expression: "form.subtotal_no_sujeto_iva"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Subtotal N/IVA\n                      "
                              ),
                              _vm.errores.subtotal_no_sujeto_iva
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores
                                              .subtotal_no_sujeto_iva[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "subtotal_e_iva",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.subtotal_exento_iva,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "subtotal_exento_iva", $$v)
                                },
                                expression: "form.subtotal_exento_iva"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Subtotal E/I\n                      "
                              ),
                              _vm.errores.subtotal_exento_iva
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores.subtotal_exento_iva[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "total_irbpnr",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.total_irbpnr,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "total_irbpnr", $$v)
                                },
                                expression: "form.total_irbpnr"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Total IRBPNR\n                      "
                              ),
                              _vm.errores.total_irbpnr
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.total_irbpnr[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-lg-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "subtotal_iva",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.subtotal_iva,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "subtotal_iva", $$v)
                                },
                                expression: "form.subtotal_iva"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Subtotal IVA\n                      "
                              ),
                              _vm.errores.subtotal_iva
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.subtotal_iva[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "subtotal_iva_0",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.subtotal_iva_0,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "subtotal_iva_0", $$v)
                                },
                                expression: "form.subtotal_iva_0"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Subtotal IVA 0%\n                      "
                              ),
                              _vm.errores.subtotal_iva_0
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.subtotal_iva_0[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "iva",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.iva,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "iva", $$v)
                                },
                                expression: "form.iva"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      IVA\n                      "
                              ),
                              _vm.errores.iva
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.errores.iva[0]))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "ice",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.ice,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "ice", $$v)
                                },
                                expression: "form.ice"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      ICE\n                      "
                              ),
                              _vm.errores.ice
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.errores.ice[0]))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                id: "total",
                                placeholder: "$ #,###.##",
                                readonly: ""
                              },
                              model: {
                                value: _vm.form.total,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "total", $$v)
                                },
                                expression: "form.total"
                              }
                            },
                            [
                              _vm._v(
                                "\n                      Total\n                      "
                              ),
                              _vm.errores.total
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.errores.total[0]))
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__main-buttons" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.estado !== "PPR" &&
                        _vm.anulado !== "S" &&
                        _vm.selectedPuntoEmision != null,
                      expression:
                        "estado !== 'PPR' && anulado !== 'S' && selectedPuntoEmision != null"
                    }
                  ],
                  staticClass: "btn-success",
                  attrs: {
                    disabled:
                      (!_vm.permiteEditarComprobante && _vm.estado !== "N") ||
                      (_vm.estado === "N" && !_vm.permiteCrearComprobante) ||
                      _vm.enColaAutorizacion,
                    type: "button"
                  },
                  on: { click: _vm.guardarComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-save" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Guardar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-light btn--text",
                  attrs: {
                    disabled: !_vm.permiteCrearComprobante,
                    type: "button"
                  },
                  on: { click: _vm.nuevoComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Nuevo")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.estado !== "N" &&
                        _vm.anulado === "N" &&
                        _vm.selectedPuntoEmision != null,
                      expression:
                        "estado !== 'N' && anulado === 'N' && selectedPuntoEmision != null"
                    }
                  ],
                  staticClass: "btn-danger btn--text",
                  attrs: {
                    disabled:
                      !_vm.permiteEliminarComprobante ||
                      _vm.anular_temporal ||
                      (_vm.no_anular_consumidor_final_aut &&
                        _vm.estado == "AUT" &&
                        _vm.numero_identificacion == "9999999999999"),
                    type: "button"
                  },
                  on: { click: _vm.anularComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-ban" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Anular")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.anulado === "S" &&
                        _vm.estado === "AUT" &&
                        _vm.esElectronico,
                      expression:
                        "anulado === 'S' && estado === 'AUT' && esElectronico"
                    }
                  ],
                  staticClass: "btn-primary btn--text",
                  attrs: {
                    disabled: !_vm.permiteEliminarComprobante,
                    type: "button"
                  },
                  on: { click: _vm.enviarComprobantesAnulados }
                },
                [
                  _c("i", { staticClass: "fa fa-envelope" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Enviar comprobante anulado")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-bus200 btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.imprimirComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-print" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Imprimir")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-danger btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.imprimirPDF }
                },
                [
                  _c("i", { staticClass: "fa fa-file-pdf-o" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("RIDE")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-primary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.verAnterior }
                },
                [
                  _c("i", { staticClass: "fa fa-toggle-left" }),
                  _vm._v("Anterior\n          ")
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-primary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.verSiguiente }
                },
                [
                  _c("i", { staticClass: "fa fa-toggle-right" }),
                  _vm._v("Siguiente\n          ")
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.estado === "AUT" &&
                        (_vm.intento_correo || _vm.tipoComprobante === "00"),
                      expression:
                        "\n            estado === 'AUT' && (intento_correo || tipoComprobante === '00')\n          "
                    }
                  ],
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.enviarCorreo }
                },
                [
                  _c("i", { staticClass: "fa fa-envelope-o" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Enviar correo")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.estado !== "N" &&
                        _vm.tipoComprobante !== _vm.codigoProforma &&
                        _vm.tipoComprobante !== _vm.codigoNotaVenta,
                      expression:
                        "\n            estado !== 'N' &&\n            tipoComprobante !== codigoProforma &&\n            tipoComprobante !== codigoNotaVenta\n          "
                    }
                  ],
                  staticClass: "btn-secondary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.abrirLogs }
                },
                [
                  _c("i", { staticClass: "fa fa-file-o" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Logs")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.id_comprobante !== "" &&
                        (_vm.tipoComprobante === _vm.codigoFactura ||
                          _vm.tipoComprobante === _vm.codigoNotaVenta),
                      expression:
                        "\n            id_comprobante !== '' &&\n            (tipoComprobante === codigoFactura ||\n              tipoComprobante === codigoNotaVenta)\n          "
                    }
                  ],
                  staticClass: "btn-dark btn--text",
                  attrs: { disabled: !_vm.permiteAbonarFactura },
                  on: { click: _vm.abrirAbonos }
                },
                [
                  _c("i", { staticClass: "fa fa-money" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Abonos")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.estado !== "N" &&
                        (_vm.estado === undefined || _vm.estado === null) &&
                        _vm.anulado === "N" &&
                        !_vm.enColaAutorizacion &&
                        ((_vm.permiteAutorizarFactura &&
                          _vm.tipoComprobante === "01") ||
                          (_vm.permiteAutorizarNc &&
                            _vm.tipoComprobante === "04")),
                      expression:
                        "\n            estado !== 'N' &&\n            (estado === undefined || estado === null) &&\n            anulado === 'N' &&\n            !enColaAutorizacion &&\n            ((permiteAutorizarFactura && tipoComprobante === '01') ||\n              (permiteAutorizarNc && tipoComprobante === '04'))\n          "
                    }
                  ],
                  staticClass: "btn-primary btn--text",
                  on: { click: _vm.autorizar }
                },
                [
                  _c("i", { staticClass: "fa fa-paper-plane" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Autorizar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.estado !== "N" &&
                        _vm.anulado === "N" &&
                        _vm.tipoComprobante === _vm.codigoFactura,
                      expression:
                        "\n            estado !== 'N' &&\n            anulado === 'N' &&\n            tipoComprobante === codigoFactura\n          "
                    }
                  ],
                  staticClass: "btn-danger btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.notificarDeuda }
                },
                [
                  _c("i", { staticClass: "fa fa-flag" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Notificar deuda")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.estado !== "N" &&
                        _vm.tipoComprobante === "01" &&
                        _vm.permiteClonar,
                      expression:
                        "\n            estado !== 'N' && tipoComprobante === '01' && permiteClonar\n          "
                    }
                  ],
                  staticClass: "btn-primary btn--text",
                  on: { click: _vm.clonar }
                },
                [
                  _c("i", { staticClass: "fa fa-clone" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Clonar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N" && _vm.tipoComprobante === "01",
                      expression: "estado !== 'N' && tipoComprobante === '01'"
                    }
                  ],
                  staticClass: "btn-warning btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.generarGuia }
                },
                [
                  _c("i", { staticClass: "fa fa-file" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Generar guía")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.mostrarAuditorias }
                },
                [
                  _c("i", { staticClass: "fa fa-file" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Auditorías")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.compras.length > 0,
                      expression: "form.compras.length > 0"
                    }
                  ],
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$modal.show("comprasAsignadas")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-eye" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Compras asignadas")])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "85%",
            height: "auto",
            scrollable: "",
            name: "listaComprobantes"
          }
        },
        [
          _c("lista-comprobantes", {
            attrs: { tipoComprobante: _vm.tipoComprobanteConsulta },
            on: { selected: _vm.selectedComprobante }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "55%",
            height: "auto",
            name: "listaPersonas",
            scrollable: ""
          }
        },
        [
          _c("lista-personas", {
            attrs: { tipoFiltro: "C", filterStatus: false },
            on: { selected: _vm.selectedPersona }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: _vm.personaClosable,
            scrollable: "",
            width: "70%",
            height: "auto",
            name: "persona"
          }
        },
        [
          _c("persona", {
            attrs: {
              idProforma: _vm.id_proforma,
              correoPersona: _vm.form.email,
              closable: _vm.personaClosable,
              nombrePersona: _vm.nombre_cliente,
              tipoFiltro: "C",
              numeroIdentificacion: _vm.numero_identificacion,
              searchButton: false
            },
            on: { saved: _vm.savedPersona }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "listaAbonos",
            width: "70%",
            height: "auto",
            scrollable: ""
          }
        },
        [_c("lista-abonos", { attrs: { idComprobante: _vm.id_comprobante } })],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "70%",
            name: "coincidenciaComprobantes",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("coincidencia-comprobantes", {
            attrs: { comprobantes: _vm.comprobantesConsultados },
            on: {
              seleccionar: _vm.seleccionarComprobanteAfectado,
              cerrar: function($event) {
                return _vm.$modal.hide("coincidenciaComprobantes")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "50%",
            name: "imprimir",
            height: "auto",
            scrollable: ""
          }
        },
        [_c("imprimir", { attrs: { id_comprobante: _vm.id_comprobante } })],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "50%",
            name: "auditorias",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("auditorias", {
            ref: "auditorias",
            attrs: { id_comprobante: _vm.id_comprobante },
            on: { cancelar: _vm.cancelarAuditorias }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            adaptive: "",
            resizable: "",
            reset: "",
            name: "compras",
            height: "auto",
            width: "80%",
            scrollable: ""
          }
        },
        [
          _c("lista-comprobantes-compra", {
            attrs: { tipoComprobante: "01" },
            on: { selected: _vm.selectedCompra }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "comprasAsignadas",
            scrollable: "",
            width: "50%",
            height: "auto",
            adaptive: "",
            resizable: "",
            reset: ""
          }
        },
        [
          _c("compras-asignadas", {
            attrs: { compras: _vm.form.compras },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("comprasAsignadas")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "80%",
            height: "auto",
            scrollable: true,
            name: "modalListaProyectos"
          }
        },
        [_c("listaProyectos", { on: { selected: _vm.seleccionarProyecto } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "noti-info" }, [
      _c("p", [
        _c("i", { staticClass: "fa fa-info-circle" }),
        _vm._v(
          "\n                  Recuerda enviar tus comprobantes electrónicos el mismo día de su emisión para evitar sanciones. según lo establece la resolución NAC-DGERCGC25-00000014.\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Datos de Exportación")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Forma de pago")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información adicional")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Totales del comprobante")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3962487b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3962487b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/Comprobante.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3962487b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/Comprobante.vue
// module chunks = 0